import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { BrandMark } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) return navigate("/login");
      try {
        await completeGoogle(sessionId);
        window.history.replaceState(null, "", "/app");
        navigate("/app");
      } catch {
        navigate("/login");
      }
    })();
  }, [completeGoogle, navigate]);

  return (
    <div className="stp-bg flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-3 text-mist">
        <div className="animate-pulse"><BrandMark size={48} /></div>
        <p className="text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
